// extracted by mini-css-extract-plugin
export default {"locationListContent":"LocationList_locationListContent__eRwlk"};